/**
 * Mécaniques retail pédagogiques — mini-décisions interactives (ISM, facing,
 * parcours client…). Chaque situation apparaît une seule fois, espacée de
 * 5-8 jours, quand ses conditions de pertinence sont remplies.
 */
import data from '../data/dgs/mecaniques_retail.json';

export const MECANIQUES = data.mecaniques;

export const getMecanique = (id) => MECANIQUES.find(m => m.id === id) || null;

/** Prochaine situation pertinente non encore vue, ou null. */
export const prochaineMecanique = ({ retail, totalDays, month }) => {
  const vues = retail?.mecaniques?.vues || {};
  return MECANIQUES.find(m => {
    if (vues[m.id]) return false;
    const c = m.declencheur || {};
    if (c.min_jour && totalDays < c.min_jour) return false;
    if (c.mois && !c.mois.includes(month)) return false;
    if (c.caisse_malus) {
      const malus = (retail?.stats?.decompoTrafic?.caisse ?? 1) < 0.99;
      if (!malus && totalDays < (c.sinon_jour || 9999)) return false;
    }
    return true;
  }) || null;
};

/** Délai avant la prochaine situation (5-8 jours). */
export const delaiProchaineMecanique = () => 5 + Math.floor(Math.random() * 4);

/** Convertit retail.mecaniques.vues ({id: {jour, choix}}) en liste plate. */
export const vuesToList = (vues) => Object.entries(vues || {}).map(([id, v]) => ({ id, jour: v.jour, choix: v.choix }));

/** Bilan des mécaniques rencontrées : choix du joueur vs choix de l'expert (débrief PDF). */
export const bilanMecaniques = (list) => (list || [])
  .map((e) => {
    const m = getMecanique(e.id);
    if (!m) return null;
    const choix = m.choix[e.choix];
    const exp = m.expert || {};
    const expChoix = m.choix[exp.choix];
    return {
      id: m.id,
      emoji: m.emoji,
      concept: m.concept,
      jour: e.jour,
      choixIdx: e.choix,
      choixLabel: choix ? choix.label : '—',
      expertLabel: expChoix ? expChoix.label : '—',
      expertAvis: exp.avis || '',
      aligne: exp.choix === e.choix,
    };
  })
  .filter(Boolean)
  .sort((a, b) => a.jour - b.jour);
